<template>
  <div class="extragas-chatbot">

    <!-- NAVBAR -->
    <nav class="eg-navbar">
      <div class="eg-navbar-inner">
        <router-link to="/Extragas-web" class="eg-logo-edge">
          <img src="@/assets/logo/extragas-logo.png" alt="EXTRA GAS" class="eg-logo-edge-img" />
        </router-link>
        <div class="eg-nav-actions">
          <router-link to="/Extragas-web" class="eg-btn eg-btn-outline">
            <Icon icon="mdi:arrow-left" class="text-base" />
            <span class="hidden sm:inline">Volver</span>
          </router-link>
          <router-link to="/login" class="eg-btn eg-btn-primary">
            <Icon icon="mdi:login" class="text-base" />
            <span class="hidden sm:inline">Iniciar Sesión</span>
          </router-link>
        </div>
      </div>
    </nav>

    <!-- CONTENIDO -->
    <div class="eg-content-wrapper">
      <!-- Hero (solo desktop) -->
      <div class="eg-hero-header">
        <div class="eg-hero-badge">
          <Icon icon="mdi:robot-happy" class="text-sm" />
          <span>Asistente Virtual</span>
        </div>
        <h2 class="eg-hero-title">
          Pide tu gas <span class="eg-text-gradient">conversando</span>
        </h2>
      </div>

      <!-- TELÉFONO / CHAT -->
      <div class="cb-phone">
        <div class="cb-wa-head">
          <div class="cb-av">
            <img src="@/assets/logo/extragas-logo.png" alt="">
          </div>
          <div class="cb-wa-info">
            <strong>{{ empresa.nombre }}</strong>
            <small>en línea</small>
          </div>
          <button class="cb-reset" @click="reiniciar" title="Empezar de nuevo">
            <Icon icon="mdi:refresh" class="text-base" />
          </button>
        </div>

        <div class="cb-chat" ref="chatRef" aria-live="polite"></div>

        <div v-if="tipoEsperado === 'botones' && botonesOpciones.length" class="cb-options">
          <button
            v-for="(op, i) in botonesOpciones"
            :key="i"
            type="button"
            class="cb-option-btn"
            @click="tocarBoton(op)"
          >
            {{ op.label }}
          </button>
        </div>

        <form
          v-if="tipoEsperado === 'texto' || tipoEsperado === 'ambos'"
          class="cb-input-bar"
          @submit.prevent="enviarMensaje"
        >
          <input
            v-model="textoEscrito"
            type="text"
            class="cb-input-txt"
            :placeholder="placeholderActual"
            autocomplete="off"
            ref="inputRef"
            :disabled="!esperandoRespuesta"
          />
          <button
            type="submit"
            class="cb-input-send"
            :disabled="!textoEscrito.trim() || !esperandoRespuesta"
            aria-label="Enviar"
          >
            <Icon icon="mdi:send" class="text-base" />
          </button>
        </form>

        <div v-if="tipoEsperado === 'ambos' && botonesOpciones.length" class="cb-options cb-options-inline">
          <button
            v-for="(op, i) in botonesOpciones"
            :key="i"
            type="button"
            class="cb-option-btn cb-option-inline"
            @click="tocarBoton(op)"
          >
            {{ op.label }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue";
import { useToast } from "vue-toastification";
import { obtenerTiposRecarga, buscarClientePorCedula } from '@/api/gas.js';
import { obtenerDatosEmpresa } from '@/utils/tenantConfig';

export default {
  name: 'ChatbotGas',
  components: { Icon },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      seq: 0,
      modo: null,
      saving: false,
      tiposRecarga: [],
      carrito: [],
      clienteEncontrado: null,
      textoEscrito: '',
      placeholderActual: 'Escribe un mensaje…',
      esperandoRespuesta: false,
      botonesOpciones: [],
      resolverActual: null,
      tipoEsperado: 'texto',
      empresa: {
        nombre: 'EXTRA GAS',
        rif: 'J-41023119-0',
        direccion: 'C.C. LATIN CENTER PB LOCAL 01',
        ciudad: 'ACARIGUA - PORTUGUESA'
      },
      form: {
        nombre: '', apellido: '', cedula: '', telefono: '', email: '',
        direccion: '', urlMapa: '', puntoReferencia: '', tipoCliente: 'residencial'
      }
    };
  },
  computed: {
    totalGeneralBs() {
      return this.carrito.reduce((s, i) => {
        return s + Number(i.precioBs || 0) * Number(i.cantidad || 0);
      }, 0);
    }
  },
  async mounted() {
    this.cargarEmpresa();
    await this.cargarTipos();
    this.reiniciar();
  },
  methods: {
    cargarEmpresa() {
      try {
        const d = obtenerDatosEmpresa();
        if (d) {
          this.empresa = {
            nombre: d.nombreComercial || d.nombre || this.empresa.nombre,
            rif: d.rif || this.empresa.rif,
            direccion: d.direccion || this.empresa.direccion,
            ciudad: d.ciudad || this.empresa.ciudad
          };
        }
      } catch (e) { /* noop */ }
    },

    async cargarTipos() {
      try {
        const res = await obtenerTiposRecarga('activos');
        if (res?.success === true) {
          this.tiposRecarga = Array.isArray(res.data) ? res.data : [];
        }
      } catch (e) {
        console.error('Error cargando tipos:', e);
        this.tiposRecarga = [];
      }
    },

    scrollBottom() {
      this.$nextTick(() => {
        const el = this.$refs.chatRef;
        if (el) el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });
        const inp = this.$refs.inputRef;
        if (inp && this.esperandoRespuesta && this.tipoEsperado !== 'botones') inp.focus();
      });
    },

    msg(texto, who = 'in') {
      const el = document.createElement('div');
      el.className = 'cb-msg ' + who;
      el.innerHTML = texto;
      this.$refs.chatRef.appendChild(el);
      this.scrollBottom();
      return el;
    },

    bot(texto, delay = 700) {
      const my = this.seq;
      return new Promise((resolve) => {
        const t = document.createElement('div');
        t.className = 'cb-typing';
        t.innerHTML = '<i></i><i></i><i></i>';
        this.$refs.chatRef.appendChild(t);
        this.scrollBottom();
        setTimeout(() => {
          t.remove();
          if (my !== this.seq) return resolve();
          this.msg(texto);
          resolve();
        }, delay);
      });
    },

    esperarRespuesta(opts = {}) {
      return new Promise((resolve) => {
        this.placeholderActual = opts.placeholder || 'Escribe un mensaje…';
        this.botonesOpciones = opts.botones || [];
        this.tipoEsperado = opts.tipo || 'texto';
        this.esperandoRespuesta = true;
        this.resolverActual = resolve;
        this.scrollBottom();
      });
    },

    enviarMensaje() {
      const txt = (this.textoEscrito || '').trim();
      if (!txt || !this.esperandoRespuesta || !this.resolverActual) return;
      this.msg(this.escapar(txt), 'out');
      this.textoEscrito = '';
      const resolver = this.resolverActual;
      this.resolverActual = null;
      this.esperandoRespuesta = false;
      this.botonesOpciones = [];
      resolver(txt);
    },

    tocarBoton(op) {
      if (!this.esperandoRespuesta || !this.resolverActual) return;
      this.msg(this.escapar(op.label), 'out');
      const resolver = this.resolverActual;
      this.resolverActual = null;
      this.esperandoRespuesta = false;
      this.botonesOpciones = [];
      resolver(op.value);
    },

    escapar(s) {
      return String(s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    },

    async reiniciar() {
      this.seq++;
      this.modo = null;
      this.saving = false;
      this.carrito = [];
      this.clienteEncontrado = null;
      this.form = {
        nombre: '', apellido: '', cedula: '', telefono: '', email: '',
        direccion: '', urlMapa: '', puntoReferencia: '', tipoCliente: 'residencial'
      };
      this.textoEscrito = '';
      this.esperandoRespuesta = false;
      this.botonesOpciones = [];
      this.resolverActual = null;
      this.$refs.chatRef.innerHTML = '';

      await this.bot('¡Hola! 👋 Soy el asistente de <b>' + this.empresa.nombre + '</b> 🔥');
      await this.bot('Te ayudo a pedir tu gas a domicilio. ¿Empezamos?', 500);

      const r = await this.esperarRespuesta({
        botones: [{ label: '🚀 Empezar', value: 'si' }],
        tipo: 'botones'
      });

      if (r === 'si') await this.preguntarModo();
    },

    async preguntarModo() {
      await this.bot('¿Eres cliente nuevo o ya has pedido antes?');
      const r = await this.esperarRespuesta({
        botones: [
          { label: '🆕 Soy cliente nuevo', value: 'nuevo' },
          { label: '🔍 Ya soy cliente', value: 'existente' }
        ],
        tipo: 'botones'
      });
      if (r === 'nuevo') {
        this.modo = 'nuevo';
        await this.flujoNuevo();
      } else {
        this.modo = 'existente';
        await this.flujoExistente();
      }
    },

    async flujoExistente() {
      await this.bot('¡Perfecto! Dime tu cédula y la busco en el sistema.');
      const cedula = await this.pedirCedula();

      await this.bot('🔍 Buscando en la base de datos…', 500);
      try {
        const res = await buscarClientePorCedula(cedula);
        if (res?.success && res.data) {
          this.clienteEncontrado = res.data;
          this.form = {
            nombre: res.data.nombre || '',
            apellido: res.data.apellido || '',
            cedula: res.data.cedula || cedula,
            telefono: res.data.telefono || '',
            email: res.data.email || '',
            direccion: res.data.direccion || '',
            urlMapa: res.data.urlMapa || '',
            puntoReferencia: res.data.puntoReferencia || '',
            tipoCliente: res.data.tipoCliente || 'residencial'
          };

          await this.bot('✅ <b>¡Ya te encontré, ' + res.data.nombre + '!</b>');
          await this.bot('Veo que has pedido ' + (res.data.totalPedidos || 0) + ' veces antes. 🙌', 500);

          await this.confirmarDatosGuardados();
          await this.confirmarDireccion();
          await this.pedirServicios();
          await this.confirmarYEnviar();
          return;
        }
      } catch (e) {
        console.error(e);
      }

      this.clienteEncontrado = null;
      await this.bot('😕 No encontré esa cédula en el sistema.');
      const r = await this.esperarRespuesta({
        botones: [
          { label: '🆕 Registrarme como nuevo', value: 'nuevo' },
          { label: '🔁 Intentar otra cédula', value: 'retry' }
        ],
        tipo: 'botones'
      });
      if (r === 'retry') return this.flujoExistente();
      this.modo = 'nuevo';
      await this.flujoNuevo();
    },

    async confirmarDatosGuardados() {
      await this.bot(
        'Estos son los datos que tengo guardados:\n' +
        '📞 ' + this.form.telefono + '\n' +
        '📧 ' + this.form.email + '\n' +
        '¿Están correctos?'
      );
      const r = await this.esperarRespuesta({
        botones: [
          { label: '✅ Sí, están bien', value: 'si' },
          { label: '✏️ Quiero cambiarlos', value: 'no' }
        ],
        tipo: 'botones'
      });
      if (r === 'no') {
        await this.bot('¿Cuál es tu nuevo teléfono?');
        this.form.telefono = await this.pedirTelefono();
        await this.bot('¿Y tu nuevo email?');
        this.form.email = await this.pedirEmail();
        await this.bot('✅ Datos actualizados.');
      } else {
        await this.bot('Genial. 👍');
      }
    },

    async confirmarDireccion() {
      if (!this.form.direccion) {
        await this.bot('No tengo tu dirección guardada. ¿Me la das?');
        await this.pedirDireccionCompleta();
        return;
      }
      await this.bot('📍 Entregamos en:\n<b>' + this.form.direccion + '</b>\n¿Está bien?');
      const r = await this.esperarRespuesta({
        botones: [
          { label: '✅ Sí, ahí mismo', value: 'si' },
          { label: '✏️ Cambiar dirección', value: 'no' }
        ],
        tipo: 'botones'
      });
      if (r === 'no') await this.pedirDireccionCompleta();
      else await this.bot('Perfecto. 📍');
    },

    async flujoNuevo() {
      await this.bot('¡Excelente! Vamos a crear tu cuenta. 🚀');

      await this.bot('¿Cuál es tu nombre?');
      const nombre = await this.pedirNombre();
      this.form.nombre = nombre;

      await this.bot('Gracias, ' + nombre + '. ¿Y tu apellido?', 500);
      const apellido = await this.pedirApellido();
      this.form.apellido = apellido;

      await this.bot('Encantado, ' + nombre + ' ' + apellido + ' 👋');
      await this.bot('Ahora dime tu cédula.', 500);
      this.form.cedula = await this.pedirCedula();

      await this.bot('¿Cuál es tu número de teléfono?');
      this.form.telefono = await this.pedirTelefono();

      await this.bot('¿Y tu correo electrónico?');
      this.form.email = await this.pedirEmail();

      await this.pedirDireccionCompleta();

      await this.bot('¿Qué tipo de cliente eres?');
      const tipo = await this.esperarRespuesta({
        botones: [
          { label: '🏠 Residencial', value: 'residencial' },
          { label: '🏢 Comercial', value: 'comercial' },
          { label: '🏭 Industrial', value: 'industrial' }
        ],
        tipo: 'botones'
      });
      this.form.tipoCliente = tipo;

      await this.pedirServicios();
      await this.confirmarYEnviar();
    },

    async pedirDireccionCompleta() {
      await this.bot('Dime la dirección donde te entregamos el gas.');
      const dir = await this.esperarRespuesta({
        placeholder: 'Ej: Calle 5 con Av. 8, Casa 12',
        tipo: 'texto'
      });
      if (dir.length < 5) {
        await this.bot('Escribe una dirección más completa por favor.');
        return this.pedirDireccionCompleta();
      }
      this.form.direccion = dir;

      await this.bot('¿Me compartes el link de Google Maps con tu ubicación exacta?');
      await this.bot('💡 Abre Google Maps → toca tu ubicación → Compartir → pega el enlace aquí.', 500);
      const mapa = await this.esperarRespuesta({
        placeholder: 'https://maps.google.com/?q=...',
        tipo: 'texto'
      });
      if (!mapa.toLowerCase().includes('http')) {
        await this.bot('El enlace debe empezar con https:// — intenta de nuevo.');
        return this.pedirDireccionCompleta();
      }
      this.form.urlMapa = mapa;

      await this.bot('¿Algún punto de referencia para el repartidor?');
      const ref = await this.esperarRespuesta({
        placeholder: 'Ej: Frente a la panadería',
        botones: [{ label: '⏭️ Omitir', value: 'omitir' }],
        tipo: 'ambos'
      });
      this.form.puntoReferencia = ref === 'omitir' ? '' : ref;
    },

    async pedirNombre() {
      const v = await this.esperarRespuesta({ placeholder: 'Ej: Juan', tipo: 'texto' });
      if (v.length < 2) {
        await this.bot('Escribe tu nombre por favor.');
        return this.pedirNombre();
      }
      return this.capitalizar(v);
    },
    async pedirApellido() {
      const v = await this.esperarRespuesta({ placeholder: 'Ej: Pérez', tipo: 'texto' });
      if (v.length < 2) {
        await this.bot('Escribe tu apellido por favor.');
        return this.pedirApellido();
      }
      return this.capitalizar(v);
    },
    async pedirCedula() {
      const v = await this.esperarRespuesta({ placeholder: 'Ej: V-12345678', tipo: 'texto' });
      if (v.replace(/\D/g, '').length < 6) {
        await this.bot('La cédula debe tener al menos 6 números. Intenta de nuevo.');
        return this.pedirCedula();
      }
      return this.formatearCedula(v);
    },
    async pedirTelefono() {
      const v = await this.esperarRespuesta({ placeholder: 'Ej: 0416-1234567', tipo: 'texto' });
      if (v.replace(/\D/g, '').length < 10) {
        await this.bot('El teléfono debe tener al menos 10 dígitos. Intenta de nuevo.');
        return this.pedirTelefono();
      }
      return this.formatearTelefono(v);
    },
    async pedirEmail() {
      const v = await this.esperarRespuesta({ placeholder: 'Ej: juan@correo.com', tipo: 'texto' });
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) {
        await this.bot('Ese correo no parece válido. Intenta de nuevo.');
        return this.pedirEmail();
      }
      return v.toLowerCase();
    },

    async pedirServicios() {
      if (!this.tiposRecarga.length) {
        await this.bot('😕 No hay servicios disponibles en este momento.');
        return;
      }

      await this.bot('Estos son los servicios que tenemos hoy 👇');
      this.carrito = [];

      while (true) {
        const botonesServicios = this.tiposRecarga.map((t) => ({
          label: t.nombre + ' (' + this.formatearNumero(t.kilogramos, 0) + ' kg) — Bs. ' + this.formatearNumero(t.precioBs, 2),
          value: 'add:' + t.idTipoRecarga
        }));
        botonesServicios.push({ label: '✅ Terminar pedido', value: 'fin' });

        const r = await this.esperarRespuesta({
          botones: botonesServicios,
          tipo: 'botones'
        });

        if (r === 'fin') {
          if (!this.carrito.length) {
            await this.bot('😕 Aún no has agregado ninguna bombona. Elige al menos una por favor.');
            continue;
          }
          break;
        }

        if (typeof r === 'string' && r.startsWith('add:')) {
          const id = r.replace('add:', '');
          const t = this.tiposRecarga.find((x) => String(x.idTipoRecarga) === String(id));
          if (!t) continue;

          await this.bot('¿Cuántas de <b>' + t.nombre + '</b> quieres?');
          const cantResp = await this.esperarRespuesta({
            placeholder: 'Escribe un número (ej: 3)',
            tipo: 'texto'
          });

          const numParsed = parseInt(cantResp, 10);
          if (isNaN(numParsed) || numParsed < 1) {
            await this.bot('😕 No entendí. Por favor escribe un número mayor a 0.');
            continue;
          }
          const cantidad = Math.min(99, numParsed);
          if (numParsed > 99) {
            await this.bot('⚠️ El máximo por servicio es 99. Te agrego 99.');
          }

          const existente = this.carrito.find((i) => i.idTipoRecarga === t.idTipoRecarga);
          if (existente) {
            existente.cantidad += cantidad;
          } else {
            this.carrito.push({
              idTipoRecarga: t.idTipoRecarga,
              nombre: t.nombre,
              codigo: t.codigo,
              kilogramos: t.kilogramos,
              litrosEquivalente: t.litrosEquivalente,
              precioBs: Number(t.precioBs || 0),
              cantidad: cantidad
            });
          }

          const resumen = this.carrito
            .map((i) => '• ' + i.cantidad + ' × ' + i.nombre + ' = Bs. ' + this.formatearNumero(i.precioBs * i.cantidad, 2))
            .join('\n');
          await this.bot(
            '✅ Agregado: <b>' + cantidad + ' × ' + t.nombre + '</b>\n\n' +
            '<b>Tu pedido hasta ahora:</b>\n' + resumen +
            '\n\n<b>Total: Bs. ' + this.formatearNumero(this.totalGeneralBs, 2) + '</b>\n\n' +
            '¿Quieres agregar más o terminamos?'
          );
        }
      }

      const resumen = this.carrito
        .map((i) => '• ' + i.cantidad + ' × ' + i.nombre + ' = Bs. ' + this.formatearNumero(i.precioBs * i.cantidad, 2))
        .join('\n');
      await this.bot(
        '<b>🛒 Pedido final:</b>\n' + resumen +
        '\n\n<b>💰 Total: Bs. ' + this.formatearNumero(this.totalGeneralBs, 2) + '</b>'
      );

      const conf = await this.esperarRespuesta({
        botones: [
          { label: '✅ Sí, está bien', value: 'ok' },
          { label: '🔁 Cambiar pedido', value: 'again' }
        ],
        tipo: 'botones'
      });
      if (conf === 'again') {
        this.carrito = [];
        return this.pedirServicios();
      }
    },

    async confirmarYEnviar() {
      await this.bot('📋 Reviso todo antes de enviar…', 500);
      await this.bot(
        '<b>Resumen:</b>\n' +
        '👤 ' + this.form.nombre + ' ' + this.form.apellido + '\n' +
        '🆔 ' + this.form.cedula + '\n' +
        '📞 ' + this.form.telefono + '\n' +
        '📧 ' + this.form.email + '\n' +
        '📍 ' + this.form.direccion + '\n' +
        '🚚 ' + this.carrito.map((i) => i.cantidad + '×' + i.nombre).join(', ') + '\n' +
        '<b>💰 Total: Bs. ' + this.formatearNumero(this.totalGeneralBs, 2) + '</b>'
      );

      const conf = await this.esperarRespuesta({
        botones: [
          { label: '✅ Confirmar pedido', value: 'si' },
          { label: '❌ Cancelar', value: 'no' }
        ],
        tipo: 'botones'
      });
      if (conf === 'no') {
        await this.bot('Pedido cancelado. 👋');
        return;
      }
      await this.enviarPedido();
    },

    async enviarPedido() {
      if (this.saving) return;
      this.saving = true;
      await this.bot('📤 Enviando tu pedido…', 600);

      try {
        const { apiFetch } = await import('@/api/index.js');
        const servicios = this.carrito.map((i) => ({
          idTipoRecarga: i.idTipoRecarga,
          cantidad: i.cantidad
        }));

        let endpoint, payload;
        if (this.modo === 'nuevo') {
          endpoint = '/api/ClienteGas/registro-web';
          payload = {
            nombre: this.form.nombre.trim(),
            apellido: this.form.apellido.trim(),
            cedula: this.form.cedula.trim(),
            telefono: this.form.telefono.trim(),
            email: this.form.email.trim().toLowerCase(),
            direccion: this.form.direccion.trim(),
            urlMapa: this.form.urlMapa.trim(),
            puntoReferencia: this.form.puntoReferencia?.trim() || null,
            tipoCliente: this.form.tipoCliente,
            servicios
          };
        } else {
          endpoint = '/api/ClienteGas/pedido-web';
          payload = {
            cedula: this.form.cedula.trim(),
            telefono: this.form.telefono.trim(),
            email: this.form.email.trim().toLowerCase(),
            direccion: this.form.direccion.trim(),
            urlMapa: this.form.urlMapa.trim(),
            puntoReferencia: this.form.puntoReferencia?.trim() || null,
            tipoCliente: this.form.tipoCliente,
            servicios
          };
        }

        const response = await apiFetch(endpoint, {
          method: 'POST',
          body: JSON.stringify(payload)
        });

        if (!response) {
          await this.bot('⚠️ No se recibió respuesta del servidor.');
          return;
        }
        if (response.success === false) {
          await this.bot('⚠️ ' + (response.error || 'Error al procesar.'));
          return;
        }

        const numeroPedido =
          response?.data?.pedido?.numeroPedido ||
          response?.data?.pedido?.numero_pedido ||
          response?.data?.numeroPedido ||
          response?.data?.numero_pedido ||
          response?.pedido?.numeroPedido ||
          response?.pedido?.numero_pedido ||
          response?.numeroPedido ||
          response?.numero_pedido ||
          null;

        const codigoEntrega =
          response?.data?.pedido?.codigoEntrega ||
          response?.data?.pedido?.codigo_entrega ||
          response?.data?.cliente?.codigoEntrega ||
          response?.data?.cliente?.codigo_entrega ||
          response?.data?.codigoEntrega ||
          response?.pedido?.codigoEntrega ||
          response?.cliente?.codigoEntrega ||
          response?.codigoEntrega ||
          null;

        sessionStorage.setItem('gas_registro_confirmacion', JSON.stringify({
          modo: this.modo,
          nombre: payload.nombre || this.clienteEncontrado?.nombre || '',
          apellido: payload.apellido || this.clienteEncontrado?.apellido || '',
          cedula: payload.cedula,
          telefono: payload.telefono,
          direccion: payload.direccion,
          urlMapa: payload.urlMapa,
          puntoReferencia: payload.puntoReferencia,
          numeroPedido,
          codigoEntrega,
          servicios: this.carrito.map((i) => ({
            nombre: i.nombre,
            codigo: i.codigo,
            cantidad: i.cantidad,
            kilogramos: i.kilogramos,
            precioBs: i.precioBs,
            subtotalBs: i.precioBs * i.cantidad
          })),
          totalBs: this.totalGeneralBs
        }));

        await this.bot(
          '✅ <b>¡Pedido ' + (numeroPedido ? 'EG-' + numeroPedido : 'confirmado') + '!</b>\n' +
          '💰 Total: Bs. ' + this.formatearNumero(this.totalGeneralBs, 2) + '\n' +
          '🚚 Llegada estimada: 45–60 min.\n' +
          '🔄 Ten lista tu bombona vacía para el cambio.',
          900
        );

        this.toast.success(
          this.modo === 'nuevo'
            ? '¡Registro exitoso! Redirigiendo…'
            : '¡Pedido enviado! Redirigiendo…'
        );

        setTimeout(() => {
          this.$router.push('/gas/registro/confirmacion');
        }, 2000);

      } catch (error) {
        console.error('💥 Error en envío:', error);
        await this.bot('⚠️ ' + (error?.message || 'Error al procesar.'));
        this.toast.error(error?.message || 'Error al procesar');
      } finally {
        this.saving = false;
      }
    },

    formatearCedula(v) {
      const valor = (v || '').toUpperCase().replace(/[^VEJPG0-9]/g, '');
      const letra = (valor.match(/^[VEJPG]/) || ['V'])[0];
      const num = valor.replace(/[^0-9]/g, '');
      return num ? letra + '-' + num : letra;
    },
    formatearTelefono(v) {
      let val = (v || '').replace(/[^0-9]/g, '');
      if (val.length > 11) val = val.substring(0, 11);
      if (val.length > 4) return val.substring(0, 4) + '-' + val.substring(4);
      return val;
    },
    capitalizar(s) {
      return (s || '').charAt(0).toUpperCase() + (s || '').slice(1).toLowerCase();
    },
    formatearNumero(v, dec = 2) {
      if (v === null || v === undefined || v === '') return '0';
      const n = Number(v);
      if (isNaN(n)) return '0';
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: dec,
        maximumFractionDigits: dec
      }).format(n);
    }
  }
};
</script>

<style scoped>
/* ═══════════════════════════════════════════════════════
   BASE
═══════════════════════════════════════════════════════ */
.extragas-chatbot {
  font-family: 'Lexend', -apple-system, BlinkMacSystemFont, sans-serif;
  color: #0f1a2f;
  min-height: 100vh;
  min-height: 100dvh;
  background: #f0f4fa;
  background-image:
    radial-gradient(circle at 0% 0%, rgba(93, 173, 226, 0.15) 0%, transparent 40%),
    radial-gradient(circle at 100% 100%, rgba(232, 122, 48, 0.12) 0%, transparent 40%);
  background-attachment: fixed;
  display: flex;
  flex-direction: column;
}

/* ═══════════════════════════════════════════════════════
   NAVBAR
═══════════════════════════════════════════════════════ */
.eg-navbar {
  position: sticky;
  top: 0;
  z-index: 100;
  background: rgba(15, 26, 47, 0.98);
  backdrop-filter: blur(16px);
  border-bottom: 1px solid rgba(232, 122, 48, 0.2);
  min-height: 72px;
  display: flex;
  align-items: center;
  box-shadow: 0 4px 20px rgba(15, 26, 47, 0.15);
  flex-shrink: 0;
}
.eg-navbar-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
  padding: 0 1.5rem 0 0;
}
.eg-logo-edge {
  display: flex;
  align-items: center;
  padding: 6px 20px;
  text-decoration: none;
}
.eg-logo-edge-img {
  height: 62px;
  width: auto;
  object-fit: contain;
  transition: transform 0.3s ease;
}
.eg-logo-edge:hover .eg-logo-edge-img { transform: scale(1.05); }

.eg-nav-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding-right: 1rem;
}
.eg-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.7rem 1.25rem;
  font-size: 0.8rem;
  font-weight: 800;
  border-radius: 0.75rem;
  text-decoration: none;
  transition: all 0.25s ease;
  cursor: pointer;
  border: none;
  letter-spacing: 0.02em;
  white-space: nowrap;
}
.eg-btn-primary {
  background: linear-gradient(135deg, #E87A30 0%, #FF9F5A 100%);
  color: white;
  box-shadow: 0 6px 20px rgba(232, 122, 48, 0.4);
}
.eg-btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 28px rgba(232, 122, 48, 0.55);
}
.eg-btn-outline {
  background: rgba(255, 255, 255, 0.06);
  color: white;
  border: 2px solid rgba(93, 173, 226, 0.5);
}
.eg-btn-outline:hover {
  background: #5DADE2;
  border-color: #5DADE2;
  transform: translateY(-2px);
}

/* ═══════════════════════════════════════════════════════
   CONTENIDO — DESKTOP
═══════════════════════════════════════════════════════ */
.eg-content-wrapper {
  flex: 1;
  width: 100%;
  max-width: 640px;
  margin: 0 auto;
  padding: 2.5rem 1.25rem 4rem;
  min-height: 0;
}

/* HERO */
.eg-hero-header {
  text-align: center;
  margin-bottom: 1.5rem;
}
.eg-hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.55rem 1.1rem;
  background: linear-gradient(135deg, #E87A30 0%, #FF9F5A 100%);
  color: white;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 900;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin-bottom: 1rem;
  box-shadow: 0 6px 20px rgba(232, 122, 48, 0.35);
}
.eg-hero-title {
  font-size: 1.75rem;
  font-weight: 900;
  line-height: 1.15;
  color: #0f1a2f;
  margin-bottom: 0.5rem;
}
.eg-text-gradient {
  background: linear-gradient(135deg, #E87A30 0%, #5DADE2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* TELÉFONO — DESKTOP */
.cb-phone {
  background: #ECE5DD;
  border-radius: 24px;
  overflow: hidden;
  border: 6px solid #0f1a2f;
  box-shadow: 0 18px 40px -18px rgba(15, 26, 47, 0.5);
  display: flex;
  flex-direction: column;
  height: 640px;
  max-height: 82vh;
}

/* HEADER del chat */
.cb-wa-head {
  background: #0f1a2f;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  flex-shrink: 0;
}
.cb-wa-head .cb-av {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: #fff;
  display: grid;
  place-items: center;
  flex: none;
  overflow: hidden;
}
.cb-wa-head .cb-av img { height: 28px; width: auto; object-fit: contain; }
.cb-wa-info { flex: 1; min-width: 0; }
.cb-wa-head strong {
  font-size: 0.95rem;
  font-weight: 900;
  display: block;
  line-height: 1.2;
}
.cb-wa-head small { font-size: 0.7rem; opacity: 0.8; }
.cb-reset {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  border: 0;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  cursor: pointer;
  transition: background 0.2s ease;
}
.cb-reset:hover { background: rgba(255, 255, 255, 0.25); }

/* CHAT (mensajes) */
.cb-chat {
  flex: 1;
  overflow-y: auto;
  padding: 14px 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: #1B2433;
  background:
    repeating-linear-gradient(45deg, rgba(255,255,255,0.03) 0 20px, transparent 20px 40px),
    #ECE5DD;
  min-height: 0;
  -webkit-overflow-scrolling: touch;
}
.cb-msg {
  max-width: 84%;
  padding: 9px 12px;
  border-radius: 10px;
  font-size: 0.87rem;
  line-height: 1.45;
  position: relative;
  animation: cbpop 0.22s ease-out;
  white-space: pre-line;
  word-wrap: break-word;
  box-shadow: 0 1px 1px rgba(0,0,0,0.06);
}
.cb-msg.in {
  background: #fff;
  align-self: flex-start;
  border-top-left-radius: 2px;
}
.cb-msg.out {
  background: #DCF8C6;
  align-self: flex-end;
  border-top-right-radius: 2px;
}
.cb-msg b { font-weight: 700; }

.cb-typing {
  align-self: flex-start;
  background: #fff;
  border-radius: 10px;
  padding: 10px 12px;
  display: flex;
  gap: 4px;
  box-shadow: 0 1px 1px rgba(0,0,0,0.06);
}
.cb-typing i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #6B7685;
  animation: cbblink 1s infinite;
}
.cb-typing i:nth-child(2) { animation-delay: 0.15s; }
.cb-typing i:nth-child(3) { animation-delay: 0.3s; }

@keyframes cbpop {
  from { transform: translateY(6px); opacity: 0.3; }
  to { transform: none; opacity: 1; }
}
@keyframes cbblink { 50% { opacity: 0.25; } }

/* OPCIONES (botones) */
.cb-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px 14px 14px;
  background: #f0ece4;
  border-top: 1px solid rgba(0,0,0,0.05);
  flex-shrink: 0;
  max-height: 55%;
  overflow-y: auto;
}
.cb-option-btn {
  width: 100%;
  background: #fff;
  color: #1F7BB0;
  border: 1px solid #DCE3EE;
  border-radius: 12px;
  padding: 13px 16px;
  font: 700 0.88rem 'Lexend', sans-serif;
  cursor: pointer;
  transition: all 0.18s ease;
  text-align: center;
}
.cb-option-btn:hover {
  background: linear-gradient(135deg, #E87A30 0%, #FF9F5A 100%);
  color: #fff;
  border-color: #E87A30;
}

.cb-options-inline {
  flex-direction: row !important;
  flex-wrap: wrap;
  padding: 8px 10px 4px;
  max-height: none;
}
.cb-options-inline .cb-option-inline {
  width: auto;
  padding: 7px 14px;
  border-radius: 999px;
  font-size: 0.78rem;
}

/* INPUT (barra escribir) */
.cb-input-bar {
  display: flex;
  gap: 6px;
  padding: 8px 10px;
  background: #f0ece4;
  align-items: center;
  flex-shrink: 0;
  border-top: 1px solid rgba(0,0,0,0.05);
}
.cb-input-txt {
  flex: 1;
  background: #fff;
  border: 0;
  outline: 0;
  border-radius: 24px;
  padding: 11px 16px;
  font: 0.88rem 'Lexend', sans-serif;
  color: #1B2433;
}
.cb-input-txt::placeholder { color: #94a3b8; }
.cb-input-txt:disabled { background: #f1f5f9; cursor: not-allowed; }
.cb-input-send {
  width: 42px;
  height: 42px;
  border: 0;
  border-radius: 50%;
  background: linear-gradient(135deg, #E87A30 0%, #FF9F5A 100%);
  color: #fff;
  cursor: pointer;
  display: grid;
  place-items: center;
  flex-shrink: 0;
}
.cb-input-send:disabled { opacity: 0.4; cursor: not-allowed; }

/* ═══════════════════════════════════════════════════════
   📱 MÓVIL — AQUÍ ESTÁ LA CLAVE REAL
═══════════════════════════════════════════════════════ */
@media (max-width: 768px) {

  /* La raíz ocupa exactamente toda la pantalla */
  .extragas-chatbot {
    height: 100vh;
    height: 100dvh;
    min-height: 0;
    overflow: hidden;
  }

  /* Navbar compacta y fija arriba */
  .eg-navbar {
    min-height: 56px;
    flex-shrink: 0;
  }
  .eg-navbar-inner { padding: 0 0.75rem 0 0; }
  .eg-logo-edge { padding: 4px 10px; }
  .eg-logo-edge-img { height: 42px; max-width: 90px; }
  .eg-nav-actions { padding-right: 0.5rem; gap: 0.35rem; }

  /* Botones del navbar → solo iconos */
  .eg-btn {
    padding: 0.5rem !important;
    width: 38px !important;
    height: 38px !important;
    justify-content: center !important;
    border-radius: 0.6rem !important;
  }
  .eg-btn span { display: none !important; }

  /* El wrapper llena el espacio restante */
  .eg-content-wrapper {
    flex: 1;
    max-width: 100%;
    padding: 0;
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
  }

  /* Ocultar el hero header en móvil */
  .eg-hero-header { display: none; }

  /* El "teléfono" se estira para llenar el wrapper */
  .cb-phone {
    flex: 1;
    height: auto;
    max-height: none;
    border-radius: 0;
    border: 0;
    box-shadow: none;
    min-height: 0;
    overflow: hidden;
  }

  /* Header del chat */
  .cb-wa-head {
    padding: 10px 12px;
    gap: 8px;
    flex-shrink: 0;
  }
  .cb-wa-head .cb-av { width: 34px; height: 34px; }
  .cb-wa-head .cb-av img { height: 24px; }
  .cb-wa-head strong { font-size: 0.88rem; }
  .cb-wa-head small { font-size: 0.65rem; }
  .cb-reset { width: 32px; height: 32px; }

  /* Chat scrollea internamente */
  .cb-chat {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding: 10px 8px;
    gap: 5px;
  }
  .cb-msg {
    max-width: 88%;
    padding: 8px 11px;
    font-size: 0.85rem;
  }

  /* Botones — siempre visibles abajo */
  .cb-options {
    flex-shrink: 0;
    padding: 8px 10px 12px;
    padding-bottom: max(12px, env(safe-area-inset-bottom));
    gap: 6px;
    max-height: 50%;
    overflow-y: auto;
  }
  .cb-option-btn {
    padding: 12px 14px;
    font-size: 0.85rem;
    min-height: 46px;
    -webkit-tap-highlight-color: transparent;
  }

  /* Input — siempre visible abajo */
  .cb-input-bar {
    flex-shrink: 0;
    padding: 6px 8px;
    padding-bottom: max(6px, env(safe-area-inset-bottom));
    gap: 5px;
  }
  .cb-input-txt {
    padding: 10px 14px;
    font-size: 16px;
    border-radius: 20px;
  }
  .cb-input-send {
    width: 42px;
    height: 42px;
    flex-shrink: 0;
  }
}

/* MÓVILES MUY PEQUEÑOS */
@media (max-width: 380px) {
  .cb-msg { font-size: 0.82rem; padding: 7px 10px; }
  .cb-option-btn { font-size: 0.82rem; padding: 11px 12px; min-height: 44px; }
  .cb-input-txt { padding: 9px 12px; font-size: 16px; }
  .cb-input-send { width: 40px; height: 40px; }
}

/* LANDSCAPE MÓVIL */
@media (max-width: 900px) and (orientation: landscape) {
  .cb-options { max-height: 40%; }
}

/* TABLET */
@media (min-width: 769px) {
  .eg-logo-edge-img { height: 62px; }
}

/* DESKTOP GRANDE */
@media (min-width: 1024px) {
  .eg-logo-edge-img { height: 72px; }
  .eg-logo-edge { padding: 8px 24px; }
  .eg-hero-title { font-size: 2.25rem; }
  .cb-phone {
    height: 700px;
    max-height: 85vh;
  }
}
</style>